import { environment } from "@relay";
import { createRouter } from "@tanstack/react-router";
import { Environment } from "relay-runtime";
import { MockEnvironment } from "relay-test-utils";
import { routeTree } from "./routeTree.gen";

export type AppRouterContext = {
	relayEnvironment: Environment | MockEnvironment;
};

// Set up a Router instance
export const router = createRouter({
	routeTree,
	defaultPreload: "intent",
	scrollRestoration: true,
	context: {
		relayEnvironment: environment,
	} satisfies AppRouterContext,
});

// Register things for typesafety
declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}

	interface RouteContext extends AppRouterContext { }

	interface StaticDataRouteOption {
		navbarType?: "default" | "location";
	}
}
